var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 18.125C15.9067 18.125 12.9101 19.3662 10.7006 21.5756C8.49123 23.7851 7.25 26.7817 7.25 29.9062V34.4375H79.75V29.9062C79.75 28.3591 79.4453 26.8271 78.8532 25.3978C78.2611 23.9684 77.3933 22.6696 76.2994 21.5756C75.2054 20.4817 73.9066 19.6139 72.4772 19.0218C71.0479 18.4297 69.5159 18.125 67.9688 18.125H19.0312ZM79.75 39.875H7.25V57.0938C7.25 60.2183 8.49123 63.2149 10.7006 65.4244C12.9101 67.6338 15.9067 68.875 19.0312 68.875H67.9688C69.5159 68.875 71.0479 68.5703 72.4772 67.9782C73.9066 67.3861 75.2054 66.5183 76.2994 65.4244C77.3933 64.3304 78.2611 63.0316 78.8532 61.6022C79.4453 60.1729 79.75 58.6409 79.75 57.0938V39.875ZM57.0938 52.5625H66.1562C66.8773 52.5625 67.5688 52.8489 68.0787 53.3588C68.5886 53.8687 68.875 54.5602 68.875 55.2812C68.875 56.0023 68.5886 56.6938 68.0787 57.2037C67.5688 57.7136 66.8773 58 66.1562 58H57.0938C56.3727 58 55.6812 57.7136 55.1713 57.2037C54.6614 56.6938 54.375 56.0023 54.375 55.2812C54.375 54.5602 54.6614 53.8687 55.1713 53.3588C55.6812 52.8489 56.3727 52.5625 57.0938 52.5625Z",
    fill: "#5522CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.c6e3cb1115bfc09e48f0c9565e97d36f.svg";
export { ForwardRef as ReactComponent };